import classNames from "classnames";
import {
  Heading3,
  Icon,
  OrderedList,
  Paragraph,
  RenderIf,
} from "shared/components";
import { useViewMode, VIEW_MODES } from "shared/contexts/ViewMode";
import { useToggle } from "shared/hooks";

import { Item } from "../Item";
import styles from "./BlockView.module.scss";

export const BlockView = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const pointsTitle = payload?.pointsTitle ?? "";
  const points = payload?.points ?? [];
  const courses = payload?.courses ?? [];

  const { isDesktop } = useViewMode();

  const { opened, onToggle } = useToggle();

  return (
    <div className={styles.wrapper}>
      <div className={styles.blocks}>
        <div className={styles.block}>
          {!isDesktop && courses.length > 0 && (
            <div
              className={classNames(styles.dropdown, {
                [styles.opened]: opened,
              })}
              onClick={onToggle}
            >
              <Icon name="dropdown" className={styles.icon} />
            </div>
          )}
          <Heading3 className={styles.title} color="dark">
            {title}
          </Heading3>
          <Paragraph className={styles.description} color="dark">
            {description}
          </Paragraph>
          <RenderIf viewMode={VIEW_MODES.DESKTOP}>
            <Paragraph
              className={styles["points-title"]}
              color="dark"
              uppercase
              appearance="bigger"
            >
              {pointsTitle}
            </Paragraph>
            <OrderedList items={points} className={styles.points} />
          </RenderIf>
        </div>
        <div className={styles.block}>
          <RenderIf viewMode={VIEW_MODES.MOBILE}>
            {opened && (
              <div className={styles.courses}>
                {courses.map((course) => (
                  <Item item={course} key={course.id} />
                ))}
              </div>
            )}
          </RenderIf>
          <RenderIf viewMode={VIEW_MODES.DESKTOP}>
            <div className={styles.courses}>
              {courses.map((course) => (
                <Item item={course} key={course.id} />
              ))}
            </div>
          </RenderIf>
        </div>
      </div>
    </div>
  );
};
